<template>
  <component
    :is="resolvedComponent"
    v-if="datasetId && visualizationId && resolvedComponent"
    v-bind="resolvedProps"
    @series-data="$emit('series-data', $event)"
    @loading-state-changed="$emit('loading-state-changed', $event)"
    @controls-capabilities="$emit('controls-capabilities', $event)"
    @controls-changed="$emit('controls-changed', $event)"
    @interaction-active-changed="$emit('interaction-active-changed', $event)"
    @render-status="$emit('render-status', $event)"
    @select-plant="$emit('select-plant', $event)"
  />
</template>

<script setup>
  /* global defineProps, defineEmits */
  import { adaptProps, getComponent, resolveEntry } from '@/components/visualizations/visualizationRegistry';
  import { computed } from 'vue';

  const props = defineProps({
    chartId: {
      type: String,
      default: null,
    },
    datasetId: {
      type: String,
      required: true,
    },
    visualizationId: {
      type: String,
      required: true,
    },
    visualizationType: {
      type: String,
      default: '',
    },
    panelType: {
      type: String,
      default: '',
    },
    eventScope: {
      type: String,
      default: null,
    },
    labelOverrides: {
      type: Object,
      default: null,
    },
    controlOverrides: {
      type: Object,
      default: null,
    },
    styleOverrides: {
      type: Object,
      default: null,
    },
    ui: {
      type: Object,
      default: null,
    },
    dataSourceOverride: {
      type: Object,
      default: null,
    },
    // Extra query parameters (annotations, series, weather as JSON); a time series draws them.
    requestParams: {
      type: Object,
      default: null,
    },
    // Forwarded verbatim to graph-type visualizations (hides footer actions
    // in embedded contexts like the MCP widget). Null = component defaults.
    footerOptions: {
      type: Object,
      default: null,
    },
  });

  defineEmits([
    'series-data',
    'loading-state-changed',
    'controls-capabilities',
    'controls-changed',
    'interaction-active-changed',
    'render-status',
    'select-plant',
  ]);

  const entry = computed(() =>
    resolveEntry({
      key: props.panelType,
      visualizationType: props.visualizationType,
    })
  );

  const resolvedComponent = computed(() => getComponent(entry.value));
  const resolvedProps = computed(() => {
    const adapted = adaptProps(entry.value, props);
    if (props.dataSourceOverride) adapted.dataSourceOverride = props.dataSourceOverride;
    if (props.footerOptions) adapted.footerOptions = props.footerOptions;
    return adapted;
  });
</script>
